var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "load-quote-modal",
    {
      attrs: {
        active: _vm.isActive,
        "show-icon": false,
        "previous-disabled": _vm.currentStep === _vm.steps.CreateAssign.id,
        "next-disabled": _vm.currentStep === _vm.lastStep.id,
        "continue-disabled": !_vm.enableContinue,
      },
      on: {
        "update:active": function ($event) {
          _vm.isActive = $event
        },
        close: function ($event) {
          return _vm.closeModal()
        },
        previous: function ($event) {
          return _vm.previous()
        },
        next: function ($event) {
          return _vm.next()
        },
        load: function ($event) {
          return _vm.loadMessage()
        },
      },
    },
    [
      _c("p", { attrs: { slot: "text-title" }, slot: "text-title" }, [
        _vm._v("Convert to Quote"),
      ]),
      _c(
        "div",
        { attrs: { slot: "text-content" }, slot: "text-content" },
        [
          _c("load-quote-steps", {
            attrs: {
              "current-step": _vm.currentStep,
              steps: _vm.steps,
              "ecom-type": _vm.eComType,
              "enable-ecom-type-selection": _vm.enabledComTypeSelection,
            },
            model: {
              value: _vm.loadOptions,
              callback: function ($$v) {
                _vm.loadOptions = $$v
              },
              expression: "loadOptions",
            },
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }